export default __webpack_public_path__ + "static/char-v-sp02-48a3da5f0465d9b5e3578fa1793a87f5.mp4";